import type { MouseEvent } from "react";
import { RecentlyViewedRecipe, Recipe, toggleFavourite, useAppDispatch, useT } from "@reciperoll/core";
import FavouriteIcon from "./FavouriteIcon";

interface FavouriteButtonProps {
  recipe: RecentlyViewedRecipe | Recipe;
  className?: string;
}

export default function FavouriteButton({ recipe, className }: FavouriteButtonProps) {
  const t = useT();
  const dispatch = useAppDispatch();

  const favouriteHandler = (e: MouseEvent) => {
    // The button is usually nested inside a recipe <Link>; stop the click from
    // bubbling to the anchor (which would navigate) and prevent its default.
    e.preventDefault();
    e.stopPropagation();
    dispatch(toggleFavourite(recipe.id));
  };

  return (
    <button
      type="button"
      onClick={favouriteHandler}
      aria-label={recipe.favourite ? t('recipe.removeFromFavourites') : t('recipe.addToFavourites')}
      className={className}
    >
      <FavouriteIcon isFavourite={recipe.favourite} />
    </button>
  );
}
